<template>
  <div class="content-card">
    <UiSmartLink
      :to="linkUrl"
      class="content-card-link"
      :rel="isOpenInNewTab ? 'noopener noreferrer' : null"
      :target="isOpenInNewTab ? '_blank' : null"
    >
      <UiSmartImage v-bind="smartImageAttrs" class="image" />
      <div class="content">
        <p class="title headline-l">{{ title }}</p>
        <p class="subtitle body-m" v-if="subtitle">
          {{ subtitle }}
        </p>
        <slot>
          <!-- CTA is for display purposes, routing will be handled by UiSmartLink -->
          <UiMiniButton v-if="ctaText" :text="ctaText" class="cta" />
        </slot>
      </div>
    </UiSmartLink>
  </div>
</template>

<script lang="ts" setup>
import UiSmartLink from '@sephora-asia/ui-smart-link'
import UiMiniButton from '@sephora-asia/ui-mini-button'
import UiSmartImage, {
  type PropsSmartImage,
} from '@sephora-asia/ui-smart-image'
import { computed } from 'vue'
import type { PropsContentCard } from './types'

const props = withDefaults(defineProps<PropsContentCard>(), {
  textColor: 'var(--color-base-black)',
})

const smartImageAttrs = computed(
  (): PropsSmartImage => ({
    ...props.image,
    aspectRatio: props.image?.aspectRatio ?? '4/3',
    alt: props.title,
  })
)
</script>

<style lang="scss" scoped>
.content-card-link {
  display: flex;
  flex-direction: column;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    text-decoration-color: var(--color-base-black);
    cursor: pointer;
  }

  .content {
    padding: 8px;
    color: v-bind(textColor);
    background-color: v-bind(backgroundColor);

    .title {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .subtitle {
      @include lineclamp(2);
    }
  }
  .cta {
    margin-top: 8px;
  }
}
</style>
